import { createFileRoute } from "@tanstack/react-router";
import { ByggeledelsePage, byggeledelseHead } from "@/pages/ByggeledelsePage";

export const Route = createFileRoute("/byggeledelse")({
  head: () => byggeledelseHead("da"),
  component: () => <ByggeledelsePage locale="da" />,
});
